import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import {
  NgApexchartsModule,
  ChartComponent,
  ApexChart,
  ApexNonAxisChartSeries,
  ApexDataLabels,
  ApexLegend,
  ApexTooltip,
  ApexPlotOptions,
} from 'ng-apexcharts';
import { BoardsService } from '../../shared/services/boards/boards.service';
import { CommonModule } from '@angular/common';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { MatPaginatorModule, MatPaginator } from '@angular/material/paginator';
import { MatSortModule, MatSort, Sort } from '@angular/material/sort';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { TableGeneralSimpleComponent } from '../../shared/components-generals/table-general-simple/table-general-simple.component';
import { TranslateModule } from '@ngx-translate/core';
import { InputGeneral } from '../../shared/inputs/input-general/input-general';
import { FormControl, Validators } from '@angular/forms';
import { GeneralService } from '../../shared/services/general.service';
import { Subscription } from 'rxjs';
import {
  DetailExpiredPortfolioAccumulated,
  DetailPortfolioPaidMonthly,
} from '../../shared/models/boards/boards.model';
import { TabMenuSimple } from '../../shared/components-generals/tab-menu-simple/tab-menu-simple';
import { RouteService } from '../../shared/services/route.service';
import { TabRouter } from '../../shared/models/components-general/router.model';

export type ChartPieOptions = {
  series: ApexNonAxisChartSeries;
  chart: ApexChart;
  labels: any;
  dataLabels: ApexDataLabels;
  legend: ApexLegend;
  colors: string[];
  tooltip: ApexTooltip;
  plotOptions: ApexPlotOptions;
};

@Component({
  selector: 'app-boards',
  standalone: true,
  imports: [
    CommonModule,
    NgApexchartsModule,
    MatCardModule,
    MatDividerModule,
    MatProgressSpinnerModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatProgressSpinnerModule,
    TableGeneralSimpleComponent,
    TranslateModule,
    InputGeneral,
    TabMenuSimple,
  ],
  templateUrl: './boards.component.html',
  styleUrls: ['./boards.component.css'],
})
export class BoardsComponent implements OnInit {
  @ViewChild('chart') chart!: ChartComponent;

  public currentYear: number = new Date().getFullYear();
  public chartOptions: any = null;
  public nombreMesSeleccionado = '';
  public chartPieOptions: Partial<ChartPieOptions> | null = null;
  public mostrarChart = false;
  public chartExpiredPortfolioOptions: any = null;
  public chartPortfolioPaidMonthlyOptions: any = null;
  public chartWorkflowOptions: any = null;
  public analyticsRouter: TabRouter[] = [];

  //Variables tabla de cartera vencida Acumulada
  public displayedColumns: string[] = ['cliente', 'fecha_exigible', 'id_cotizacion', 'monto'];
  public displayedColumnsPaid: string[] = [
    'cliente',
    'fecha_registro',
    'fecha_deposito',
    'id_cotizacion',
    'monto',
  ];
  public dataSourceDetailExpiredPortfolioAccumulated =
    new MatTableDataSource<DetailExpiredPortfolioAccumulated>([]);
  public dataSourceDetailPortfolioPaidMonthly = new MatTableDataSource<DetailPortfolioPaidMonthly>(
    [],
  );
  public totalPortfolio: number = 0;
  public totalPayments: number = 0;
  public loadingTablePagos: boolean = false;
  public nameMonthWallet: string = '';
  public nameMonthPayments: string = '';
  public paymentType: string = '';
  public loadingTable: boolean = false;
  public inputSearchDetailExpiredPortfolioAccumulated: FormControl = new FormControl('', [
    Validators.minLength(2),
  ]);
  public subscriptionSearchDetailExpiredPortfolioAccumulated!: Subscription;
  public inputSearchDetailPortfolioPaidMonthly: FormControl = new FormControl('', [
    Validators.minLength(2),
  ]);
  public subscriptionSearchDetailPortfolioPaidMonthly!: Subscription;

  @ViewChild('MatPaginatorVencida') MatPaginatorVencida!: MatPaginator;
  @ViewChild('MatSortVencida') MatSortVencida!: MatSort;

  @ViewChild('MatPaginatorPagos') MatPaginatorPagos!: MatPaginator;
  @ViewChild('MatSortPagos') MatSortPagos!: MatSort;

  constructor(
    private boardsService: BoardsService,
    private cdr: ChangeDetectorRef,
    private generalService: GeneralService,
    private routeService: RouteService,
  ) {}

  ngOnInit(): void {
    this.analyticsRouter = this.routeService.analyticsRouter;
    this.loadPortfolioData();
    this.loadExpiredPortfolioData();
    this.loadPortfolioPaidMonthlyData();
    this.loadWorkflowData();
    this.subscribeInputDetailExpiredPortfolioAccumulated();
    this.subscribeInputDetailPortfolioPaidMonthly();
    this.dataSourceDetailExpiredPortfolioAccumulated.paginator = this.MatPaginatorVencida;
    this.dataSourceDetailExpiredPortfolioAccumulated.sort = this.MatSortVencida;
  }

  ngOnDestroy(): void {
    if (this.subscriptionSearchDetailExpiredPortfolioAccumulated) {
      this.subscriptionSearchDetailExpiredPortfolioAccumulated.unsubscribe();
    }
    if (this.subscriptionSearchDetailPortfolioPaidMonthly) {
      this.subscriptionSearchDetailPortfolioPaidMonthly.unsubscribe();
    }
  }

  // filtros de busqueda DetailExpiredPortfolioAccumulated
  public subscribeInputDetailExpiredPortfolioAccumulated(): void {
    this.subscriptionSearchDetailExpiredPortfolioAccumulated = this.generalService
      .subscribeFormSimple(this.inputSearchDetailExpiredPortfolioAccumulated)
      .subscribe((value) => {
        if (this.inputSearchDetailExpiredPortfolioAccumulated.valid) {
          this.filterDetailExpiredPortfolioAccumulated(value);
        }

        if (this.inputSearchDetailExpiredPortfolioAccumulated.value == '') {
          this.filterDetailExpiredPortfolioAccumulated(value);
        }
      });
  }

  public filterDetailExpiredPortfolioAccumulated(value: string): void {
    this.dataSourceDetailExpiredPortfolioAccumulated.filter = value.trim().toLowerCase();

    if (this.dataSourceDetailExpiredPortfolioAccumulated.paginator) {
      this.dataSourceDetailExpiredPortfolioAccumulated.paginator.firstPage();
    }
  }

  // filtros de busqueda DetailPortfolioPaidMonthly

  public subscribeInputDetailPortfolioPaidMonthly(): void {
    this.subscriptionSearchDetailPortfolioPaidMonthly = this.generalService
      .subscribeFormSimple(this.inputSearchDetailPortfolioPaidMonthly)
      .subscribe((value) => {
        if (this.inputSearchDetailPortfolioPaidMonthly.valid) {
          this.filterDetailPortfolioPaidMonthly(value);
        }

        if (this.inputSearchDetailPortfolioPaidMonthly.value == '') {
          this.filterDetailPortfolioPaidMonthly(value);
        }
      });
  }

  public filterDetailPortfolioPaidMonthly(value: string): void {
    this.dataSourceDetailPortfolioPaidMonthly.filter = value.trim().toLowerCase();

    if (this.dataSourceDetailPortfolioPaidMonthly.paginator) {
      this.dataSourceDetailPortfolioPaidMonthly.paginator.firstPage();
    }
  }

  // Comportamiento Cartera mensual
  public loadPortfolioData(): void {
    this.boardsService.getMonthlyPortfolio().subscribe((data) => {
      if (data && Array.isArray(data)) {
        const meses = data.map((item) => String(item.month));
        const debits = data.map((item) => Number(item.debit || 0));
        const credits = data.map((item) => Number(item.credit || 0));
        const numMeses = data.map((item) => Number(item.monthNumber));

        this.chartOptions = {
          series: [
            { name: 'CARGO', data: debits },
            { name: 'ABONO', data: credits },
          ],
          chart: {
            type: 'line',
            height: 400,
            toolbar: { show: true },
            events: {
              click: (event: any, chartContext: any, config: any) => {
                if (config.dataPointIndex !== -1) {
                  const mesId = numMeses[config.dataPointIndex];
                  const mesNombre = meses[config.dataPointIndex];

                  this.showDetailChart(mesId, mesNombre);
                }
              },
            },
          },
          colors: ['#007BFF', '#28A745'],
          stroke: { curve: 'smooth', width: 3 },
          markers: { size: 6 },
          xaxis: {
            categories: meses,
            labels: { style: { fontSize: '12px' } },
          },
          yaxis: {
            labels: {
              formatter: (val: number) => (val ? '$' + val.toLocaleString('en-US') : '$0'),
            },
          },
          tooltip: {
            y: {
              formatter: (val: number) => '$' + val.toLocaleString('en-US'),
            },
          },
        };
      }
    });
  }

  // Detalle mensual de cartera
  public showDetailChart(mesId: any, mesNombre: string): void {
    this.nombreMesSeleccionado = mesNombre;
    this.mostrarChart = false;

    this.boardsService.getMonthlyDetail(mesId).subscribe((res: any) => {
      if (res && Array.isArray(res) && res.length > 0) {
        const data = res[0];

        const montoExigible = Number(data.debit || 0);
        const montoAplicado = Number(data.credit || 0);

        this.chartPieOptions = {
          series: [montoExigible, montoAplicado],
          chart: {
            type: 'pie',
            height: 350,
            id: 'chart-pie-detalle',
          },
          labels: ['MONTO EXIGIBLE', 'APLICADO DEL MES'],
          colors: ['#008FFB', '#02BA26'],
          legend: { position: 'bottom' },
          dataLabels: {
            enabled: true,
            formatter: (val: any, opts: any) => {
              const valorReal = opts.w.config.series[opts.seriesIndex];
              return `$${valorReal.toLocaleString('en-US')} (${val.toFixed(1)}%)`;
            },
          },
          tooltip: {
            theme: 'dark',
            x: { show: false },
            y: {
              formatter: (val: number) =>
                `$${val.toLocaleString('en-US', { minimumFractionDigits: 2 })}`,
            },
          },
          plotOptions: {
            pie: {
              dataLabels: {
                offset: -10,
              },
            },
          },
        };
        setTimeout(() => {
          this.mostrarChart = true;
          this.cdr.detectChanges();
        }, 50);
      } else {
        console.error('El servicio no devolvió datos válidos', res);
      }
    });
  }

  // Cartera vencida acumulada
  public loadExpiredPortfolioData(): void {
    this.boardsService.getExpiredPortfolio().subscribe((resEp) => {
      const res = Array.isArray(resEp) ? resEp[0] : resEp;

      if (res && res.response) {
        try {
          const data = JSON.parse(res.response);
          this.chartExpiredPortfolioOptions = {
            series: [
              {
                name: 'Cartera Vencida',
                data: data.valores,
              },
            ],
            dataLabels: {
              enabled: false,
            },
            plotOptions: {
              bar: {
                dataLabels: {
                  position: 'top',
                },
              },
            },
            chart: {
              type: 'bar',
              height: 400,
              id: 'chart-cartera-vencida',

              animations: {
                enabled: true,
              },
              zoom: {
                enabled: false,
              },
              toolbar: {
                show: false,
              },
              events: {
                dataPointSelection: (event: any, chartContext: any, config: any) => {
                  const index = config.dataPointIndex;
                  if (index !== -1) {
                    const idMonth = data.numMes[index];
                    const month = data.meses[index];
                    const total = data.valores[index];

                    this.detailExpiredPortfolioAccumulated(idMonth, month, total);
                  }
                },
              },
            },
            xaxis: {
              categories: data.meses,
              labels: { rotate: 0, style: { fontSize: '10px' } },
            },
            yaxis: {
              labels: {
                formatter: (val: number) => '$' + val.toLocaleString('en-US'),
              },
            },
            tooltip: {
              y: {
                formatter: (val: number) =>
                  '$' + val.toLocaleString('en-US', { minimumFractionDigits: 2 }),
              },
            },
            colors: ['#e74c3c'],
          };

          this.cdr.detectChanges();
        } catch (error) {
          console.error('Error al parsear el JSON de response:', error);
        }
      }
    });
  }

  // Detalle de cartera vencida acumulada
  public detailExpiredPortfolioAccumulated(idMonth: number, month: string, total: number): void {
    this.nameMonthWallet = month;
    this.totalPortfolio = total;
    this.loadingTable = true;

    this.boardsService.getDetailExpiredPortfolioAccumulated(idMonth).subscribe({
      next: (data: any) => {
        this.dataSourceDetailExpiredPortfolioAccumulated = new MatTableDataSource(data);
        this.dataSourceDetailExpiredPortfolioAccumulated.sortingDataAccessor = (item, property) => {
          switch (property) {
            case 'fecha_exigible':
              const parts = item.DueDate.split('/');
              return new Date(+parts[2], +parts[1] - 1, +parts[0]).getTime();

            case 'id_cotizacion':
              return Number(item.QuotationId);

            case 'cliente':
              return item.Client.toLowerCase();
            default:
              return '';
          }
        };

        setTimeout(() => {
          this.dataSourceDetailExpiredPortfolioAccumulated.paginator = this.MatPaginatorVencida;
          this.dataSourceDetailExpiredPortfolioAccumulated.sort = this.MatSortVencida;
        });

        this.loadingTable = false;
        this.cdr.detectChanges();
      },
      error: (err) => {
        console.error('Error al obtener detalle:', err);
        this.loadingTable = false;
      },
    });
  }

  // Montos cobrados por mes
  public loadPortfolioPaidMonthlyData(): void {
    this.boardsService.getPortfolioPaidMonthly().subscribe((data) => {
      if (data && Array.isArray(data)) {
        const meses = data.map((item) => item.month);
        const stpValues = data.map((item) => Number(item.receivedStp || 0));
        const fileValues = data.map((item) => Number(item.receivedFile || 0));
        const numMonths = data.map((item) => item.monthNumber);

        this.chartPortfolioPaidMonthlyOptions = {
          series: [
            { name: 'Recibido STP', data: stpValues },
            { name: 'Recibido Archivo', data: fileValues },
          ],
          chart: {
            type: 'bar',
            height: 400,
            stacked: true,
            toolbar: { show: false },
            events: {
              dataPointSelection: (event: any, chartContext: any, config: any) => {
                const index = config.dataPointIndex;
                const seriesIndex = config.seriesIndex;

                if (index !== -1) {
                  const idMonth = numMonths[index];
                  const month = meses[index];
                  const total = config.w.config.series[seriesIndex].data[index];
                  const seriesName = config.w.config.series[seriesIndex].name;

                  this.detailPortfolioPaidMonthly(idMonth ?? 0, month, total, seriesName);
                }
              },
            },
          },
          xaxis: {
            categories: meses,
            labels: { style: { fontSize: '10px' } },
          },
          yaxis: {
            labels: {
              formatter: (val: number) => '$' + val.toLocaleString('en-US'),
            },
          },
          tooltip: {
            enabled: true,
            shared: true,
            intersect: false,
            y: {
              formatter: (val: number) =>
                '$' + val.toLocaleString('en-US', { minimumFractionDigits: 2 }),
            },
          },
          colors: ['#1abc9c', '#3498db'],
          dataLabels: {
            enabled: false,
          },
          legend: {
            position: 'top',
          },
        };

        this.cdr.detectChanges();
      }
    });
  }

  //Detalle de montos cobrados por mes
  public detailPortfolioPaidMonthly(
    idMonth: number,
    month: string,
    total: number,
    type: string,
  ): void {
    this.nameMonthPayments = month;
    this.paymentType = type;
    this.totalPayments = total;
    this.loadingTablePagos = true;

    var tipoNum = type === 'Recibido STP' ? 1 : 2;

    this.boardsService.getDetailPortfolioPaidMonthly(idMonth, tipoNum).subscribe({
      next: (data) => {
        if (data) {
          this.dataSourceDetailPortfolioPaidMonthly = new MatTableDataSource(data);

          this.dataSourceDetailPortfolioPaidMonthly.sortingDataAccessor = (item, property) => {
            switch (property) {
              case 'fecha_registro':
                const parts = item.RegistrationDate.split('/');
                return new Date(+parts[2], +parts[1] - 1, +parts[0]).getTime();

              case 'fecha_deposito':
                const partsDep = item.DepositDate.split('/');
                return new Date(+partsDep[2], +partsDep[1] - 1, +partsDep[0]).getTime();

              case 'id_cotizacion':
                return Number(item.QuotationId);

              case 'cliente':
                return item.Client.toLowerCase();
              default:
                return '';
            }
          };

          setTimeout(() => {
            this.dataSourceDetailPortfolioPaidMonthly.paginator = this.MatPaginatorPagos;
            this.dataSourceDetailPortfolioPaidMonthly.sort = this.MatSortPagos;
          });

          this.loadingTablePagos = false;
          this.cdr.detectChanges();
        } else {
          console.error('No se recibieron datos válidos para el detalle de pagos');
          this.loadingTablePagos = false;
        }
      },
    });
  }

  //Wokflow de cotizaciones
  public loadWorkflowData(): void {
    this.boardsService.getWorkflowQuotes().subscribe({
      next: (data) => {
        if (data && Array.isArray(data)) {
          try {
            const categorias = data.map((item) => item.description);
            const valores = data.map((item) => Number(item.total || 0));
            const colores = data.map((item) => item.color);

            this.chartWorkflowOptions = {
              series: [
                {
                  name: 'Total de cotizaciones',
                  data: valores,
                },
              ],
              chart: {
                type: 'bar',
                height: 400,
                id: 'chart-workflow-cotizaciones',
                toolbar: { show: false },
              },
              xaxis: {
                categories: categorias,
                labels: {
                  rotate: -30,
                  style: { fontSize: '11px' },
                },
              },
              colors: colores,
              plotOptions: {
                bar: {
                  distributed: true,
                },
              },
              dataLabels: {
                enabled: false,
              },
              tooltip: {
                y: {
                  formatter: (val: number) => val.toLocaleString('en-US'),
                },
              },
            };

            this.cdr.detectChanges();
          } catch (error) {
            console.error('Error al procesar los datos de la gráfica de Workflow:', error);
          }
        } else {
          console.warn('El formato recibido no es un array válido para Workflow:', data);
        }
      },
      error: (err) => console.error('Error al conectar con cotizacionesWorkflow.asp:', err),
    });
  }

  //Ordenamiento general para las tablas
  public sortTables(sort: Sort, matTableDataSource: MatTableDataSource<any>) {
    // Verificamos el ordenamiento
    if (!sort.active || sort.direction === '') {
      return;
    }

    const data = matTableDataSource.data.slice();

    matTableDataSource.data = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      const valueA = a[sort.active];
      const valueB = b[sort.active];

      //Logica de fechas"
      if (typeof valueA === 'string' && valueA.includes('/') && valueA.split('/').length === 3) {
        const [dA, mA, yA] = valueA.split('/');
        const [dB, mB, yB] = valueB.split('/');
        const dateA = new Date(+yA, +mA - 1, +dA).getTime();
        const dateB = new Date(+yB, +mB - 1, +dB).getTime();
        return this.compararValores(dateA, dateB, isAsc);
      }

      // Logica de valores numericos
      if (
        !isNaN(Number(valueA)) &&
        !isNaN(Number(valueB)) &&
        typeof valueA !== 'boolean' &&
        typeof valueB !== 'boolean'
      ) {
        return this.compararValores(Number(valueA), Number(valueB), isAsc);
      }

      // Logica de cadenas de texto
      const strA = valueA ? valueA.toString().toLowerCase() : '';
      const strB = valueB ? valueB.toString().toLowerCase() : '';
      return this.compararValores(strA, strB, isAsc);
    });
  }

  private compararValores(a: number | string, b: number | string, isAsc: boolean): number {
    if (a < b) return isAsc ? -1 : 1;
    if (a > b) return isAsc ? 1 : -1;
    return 0;
  }

  public changeSelected(url: string, index: number): void {
    this.routeService.changeSelected(url, index);
  }
}
